<template>
  <section class="h-postm-referee">
    <div class="h-postm-referee__cont-file-referee">
      <div class="h-postm-referee__cont-file-referee__item">
        <div class="h-postm-referee__cont-file-referee__item__imgreferee">
          <img
            :src="'https://golstatsimages.blob.core.windows.net/photo-referee/' + headerInfoPostMatch.referee.referee_id + '.jpg'"
          />
        </div>
        <div class="h-postm-referee__cont-file-referee__item__inforeferee">
          <div class="h-postm-referee__cont-file-referee__item__inforeferee__title">Arbitro:</div>
          <div class="h-postm-referee__cont-file-referee__item__inforeferee__name">
            {{ changeNameReferee(headerInfoPostMatch.referee.referee_name) }}
          </div>
        </div>
      </div>
    </div>
    <div class="h-postm-referee__cgen-sref">
      <div class="h-postm-referee__cgen-sref__row-yellow-card">
        <div class="h-postm-referee__cgen-sref__row-yellow-card__col-title">
          <div class="h-postm-referee__cgen-sref__row-yellow-card__col-title__name">T. Amarillas</div>
          <div class="h-postm-referee__cgen-sref__row-yellow-card__col-title__icon">
            <img src="https://golstatsimages.blob.core.windows.net/todoelfut/yelowcardhand.png" />
          </div>
          <div class="sep-div-first"></div>
        </div>
        <div class="h-postm-referee__cgen-sref__row-yellow-card__row-stats">
          <div class="h-postm-referee__cgen-sref__row-yellow-card__row-stats__home-team">
            <div class="h-postm-referee__cgen-sref__row-yellow-card__row-stats__home-team__shield">
              <img :src="'https://golstatsimages.blob.core.windows.net/teams-80/' + headerInfoPostMatch.home_team + '.png'" />
            </div>
            <div class="h-postm-referee__cgen-sref__row-yellow-card__row-stats__home-team__goals-cont-items">
              <template v-for="(item, index) in headerInfoPostMatch.home_yellow_cards_minutes">
                <div
                  :key="index"
                  class="h-postm-referee__cgen-sref__row-yellow-card__row-stats__home-team__goals-cont-items__goal"
                >
                  {{ item
                  }}<template v-if="index + 1 < headerInfoPostMatch.home_yellow_cards_minutes.length">,</template>
                </div>
              </template>
            </div>
            <div class="sep-div"></div>
          </div>
          <div class="h-postm-referee__cgen-sref__row-yellow-card__row-stats__away-team">
            <div class="h-postm-referee__cgen-sref__row-yellow-card__row-stats__away-team__shield">
              <img :src="'https://golstatsimages.blob.core.windows.net/teams-80/' + headerInfoPostMatch.visiting_team + '.png'" />
            </div>
            <div class="h-postm-referee__cgen-sref__row-yellow-card__row-stats__away-team__goals-cont-items">
              <template v-for="(item, index) in headerInfoPostMatch.visiting_yellow_cards_minutes">
                <div
                  :key="index"
                  class="h-postm-referee__cgen-sref__row-yellow-card__row-stats__away-team__goals-cont-items__goal"
                >
                  {{ item
                  }}<template v-if="index + 1 < headerInfoPostMatch.visiting_yellow_cards_minutes.length">,</template>
                </div>
              </template>
            </div>
          </div>
        </div>
      </div>
      <div class="h-postm-referee__cgen-sref__row-red-card">
        <div class="h-postm-referee__cgen-sref__row-red-card__col-title">
          <div class="h-postm-referee__cgen-sref__row-red-card__col-title__name">T. Rojas</div>
          <div class="h-postm-referee__cgen-sref__row-red-card__col-title__icon">
            <img src="https://golstatsimages.blob.core.windows.net/todoelfut/redcardhand.png" />
          </div>
          <div class="sep-div-first"></div>
        </div>
        <div class="h-postm-referee__cgen-sref__row-red-card__row-stats">
          <div class="h-postm-referee__cgen-sref__row-red-card__row-stats__home-team">
            <div class="h-postm-referee__cgen-sref__row-red-card__row-stats__home-team__shield">
              <img :src="'https://golstatsimages.blob.core.windows.net/teams-80/' + headerInfoPostMatch.home_team + '.png'" />
            </div>
            <div class="h-postm-referee__cgen-sref__row-red-card__row-stats__home-team__goals-cont-items">
              <template v-for="(item, index) in headerInfoPostMatch.home_red_cards_minutes">
                <div
                  :key="index"
                  class="h-postm-referee__cgen-sref__row-red-card__row-stats__home-team__goals-cont-items__goal"
                >
                  {{ item }}<template v-if="index + 1 < headerInfoPostMatch.home_red_cards_minutes.length">,</template>
                </div>
              </template>
            </div>
            <div class="sep-div"></div>
          </div>
          <div class="h-postm-referee__cgen-sref__row-red-card__row-stats__away-team">
            <div class="h-postm-referee__cgen-sref__row-red-card__row-stats__away-team__shield">
              <img :src="'https://golstatsimages.blob.core.windows.net/teams-80/' + headerInfoPostMatch.visiting_team + '.png'" />
            </div>
            <div class="h-postm-referee__cgen-sref__row-red-card__row-stats__away-team__goals-cont-items">
              <template v-for="(item, index) in headerInfoPostMatch.visiting_red_cards_minutes">
                <div
                  :key="index"
                  class="h-postm-referee__cgen-sref__row-red-card__row-stats__away-team__goals-cont-items__goal"
                >
                  {{ item
                  }}<template v-if="index + 1 < headerInfoPostMatch.visiting_red_cards_minutes.length">,</template>
                </div>
              </template>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'HeaderPostmatchReferee',
  components: {},
  props: {
    headerInfoPostMatch: {
      type: Object,
      required: true,
    },
  },
  computed: {},
  data() {
    return {};
  },
  methods: {
    changeNameReferee(name) {
      if (name === 'Sin designar') {
        return name;
      }
      let nameRefereePrint = '';
      if (name != null) {
        let nameTrim = name.trim();
        let auxReferee = nameTrim.split(', ');
        let apellidoAuxReferee = auxReferee[0].split(' ');
        let nameAuxReferee = auxReferee[1].split(' ');
        let auxNameInitials = '';
        for (let index = 0; index < nameAuxReferee.length; index++) {
          auxNameInitials += nameAuxReferee[index].charAt(0) + '. ';
        }
        nameRefereePrint = auxNameInitials + '' + apellidoAuxReferee[0];
      }
      return nameRefereePrint;
    },
  },
  created() {},
};
</script>
<style></style>
<style lang="scss" scoped>
.sep-div {
  width: 1px;
  height: 24px;
  border-right: 1px dotted #b4c9dd;
}
.sep-div-first {
  width: 1px;
  height: 24px;
  border-right: 1px dotted #b4c9dd;
  @media screen and (max-width: 930px) {
    display: none;
  }
}
.h-postm-referee {
  width: 100%;
  height: 78px;
  margin-top: 19px;
  // background: rgb(44, 158, 149);
  display: inline-flex;
  justify-content: space-between;
  align-content: center;
  align-items: center;
  @media screen and (max-width: 930px) {
    display: inline-block;
    height: auto;
  }
  &__cont-file-referee {
    width: 22.59%;
    height: 78px;
    border-radius: 6px;
    border: solid 1px #b4c9dd;
    overflow: hidden;
    display: inline-flex;
    justify-content: left;
    @media screen and (max-width: 930px) {
      width: 100%;
      height: 57px;
    }
    &__item {
      width: auto;
      height: 47px;
      // background: rebeccapurple;
      display: inline-flex;
      justify-content: left;
      margin-top: 15px;
      margin-left: 5%;
      align-content: center;
      align-items: center;
      @media screen and (max-width: 930px) {
        margin-left: 2%;
        margin-top: 4px;
      }
      &__imgreferee {
        width: 34px;
        height: 47px;
        img {
          width: 34px;
          border-radius: 4px;
        }
      }
      &__inforeferee {
        // background: greenyellow;
        width: auto;
        height: 47px;
        margin-left: 10px;
        &__title {
          width: 100%;
          height: 23.5px;
          font-size: 15px;
          font-weight: 500;
          font-stretch: normal;
          font-style: normal;
          line-height: 23.5px;
          letter-spacing: normal;
          text-align: left;
          color: #132839;
          font-family: 'Avenir-Demi-Medium';
        }
        &__name {
          width: 100%;
          height: 23.5px;
          font-family: 'Avenir-bold';
          font-size: 17px;
          font-weight: bold;
          font-stretch: normal;
          font-style: normal;
          line-height: 17px;
          letter-spacing: normal;
          text-align: left;
          color: #132839;
        }
      }
    }
  }
  &__cgen-sref {
    width: 76.35%;
    height: 78px;
    // background: rgb(48, 1, 1);
    @media screen and (max-width: 930px) {
      width: 100%;
      margin-top: 10px;
    }
    &__row-yellow-card {
      width: 100%;
      height: 36px;
      // background: blue;
      border-radius: 6px;
      border: solid 1px #b4c9dd;
      overflow: hidden;
      display: inline-flex;
      justify-content: left;
      @media screen and (max-width: 930px) {
        display: inline-block;
        height: auto;
      }
      &__col-title {
        width: 23.33%;
        height: 36px;
        // background: greenyellow;
        display: inline-flex;
        justify-content: space-between;
        align-content: center;
        align-items: center;
        @media screen and (max-width: 930px) {
          width: 100%;
          height: 36px;
          border-bottom: 1px dotted #b4c9dd;
        }
        &__name {
          width: 75%;
          // background: pink;
          font-size: 15px;
          font-weight: 500;
          font-stretch: normal;
          font-style: normal;
          line-height: 1.14;
          letter-spacing: normal;
          text-align: left;
          padding-left: 8%;
          color: #132839;
          font-family: 'Avenir-Medium';
          @media screen and (max-width: 930px) {
            width: 90%;
            height: auto;
            padding-left: 2%;
            font-size: 16px;
          }
        }
        &__icon {
          width: 25%;
          // background: rgb(126, 80, 87);
          display: inline-flex;
          justify-content: center;
          align-content: center;
          align-items: center;
          img {
            width: 23px;
          }
          @media screen and (max-width: 930px) {
            width: 10%;
            height: auto;
          }
        }
      }
      &__row-stats {
        width: 76.67%;
        // background: silver;
        height: 36px;
        display: inline-flex;
        justify-content: space-between;
        align-content: center;
        align-items: center;
        @media screen and (max-width: 930px) {
          width: 100%;
        }
        &__home-team {
          width: 50%;
          height: 36px;
          // background: red;
          display: inline-flex;
          justify-content: left;
          align-content: center;
          align-items: center;
          &__shield {
            width: 10%;
            height: 36px;
            // background: cyan;
            display: inline-flex;
            justify-content: center;
            align-content: center;
            align-items: center;
            img {
              width: 20px;
              @media screen and (max-width: 930px) {
                width: 24px;
              }
            }
            @media screen and (max-width: 500px) {
              width: 15%;
            }
            @media screen and (max-width: 400px) {
              width: 22%;
            }
          }
          &__goals-cont-items {
            width: 90%;
            height: 36px;
            // background: magenta;
            display: inline-flex;
            justify-content: left;
            align-content: center;
            align-items: center;
            @media screen and (max-width: 500px) {
              width: 85%;
            }
            @media screen and (max-width: 400px) {
              width: 78%;
            }
            &__goal {
              width: 12%;
              height: 36px;
              // background: brown;
              font-size: 13px;
              font-weight: 500;
              font-stretch: normal;
              font-style: normal;
              line-height: 36px;
              letter-spacing: normal;
              text-align: center;
              color: #132839;
              font-family: 'Avenir-Medium';
              @media screen and (max-width: 500px) {
                width: 18%;
              }
              @media screen and (max-width: 400px) {
                width: 22%;
              }
            }
          }
        }
        &__away-team {
          width: 50%;
          height: 36px;
          // background: red;
          display: inline-flex;
          justify-content: left;
          align-content: center;
          align-items: center;
          &__shield {
            width: 10%;
            height: 36px;
            // background: cyan;
            display: inline-flex;
            justify-content: center;
            align-content: center;
            align-items: center;
            img {
              width: 20px;
              @media screen and (max-width: 930px) {
                width: 24px;
              }
            }
            @media screen and (max-width: 500px) {
              width: 15%;
            }
            @media screen and (max-width: 400px) {
              width: 22%;
            }
          }
          &__goals-cont-items {
            width: 90%;
            height: 36px;
            // background: magenta;
            display: inline-flex;
            justify-content: left;
            align-content: center;
            align-items: center;
            @media screen and (max-width: 500px) {
              width: 85%;
            }
            @media screen and (max-width: 400px) {
              width: 78%;
            }
            &__goal {
              width: 12%;
              height: 36px;
              // background: brown;
              font-size: 13px;
              font-weight: 500;
              font-stretch: normal;
              font-style: normal;
              line-height: 36px;
              letter-spacing: normal;
              text-align: center;
              color: #132839;
              font-family: 'Avenir-Medium';
              @media screen and (max-width: 500px) {
                width: 18%;
              }
              @media screen and (max-width: 400px) {
                width: 22%;
              }
            }
          }
        }
      }
    }
    &__row-red-card {
      width: 100%;
      height: 36px;
      // background: blue;
      border-radius: 6px;
      border: solid 1px #b4c9dd;
      overflow: hidden;
      display: inline-flex;
      justify-content: left;
      margin-top: 6px;
      @media screen and (max-width: 930px) {
        display: inline-block;
        height: auto;
      }
      &__col-title {
        width: 23.33%;
        height: 36px;
        // background: greenyellow;
        display: inline-flex;
        justify-content: space-between;
        align-content: center;
        align-items: center;
        @media screen and (max-width: 930px) {
          width: 100%;
          height: 36px;
          border-bottom: 1px dotted #b4c9dd;
        }
        &__name {
          width: 75%;
          // background: pink;
          font-size: 15px;
          font-weight: 500;
          font-stretch: normal;
          font-style: normal;
          line-height: 1.14;
          letter-spacing: normal;
          text-align: left;
          padding-left: 8%;
          color: #132839;
          font-family: 'Avenir-Medium';
          @media screen and (max-width: 930px) {
            width: 90%;
            height: auto;
            padding-left: 2%;
            font-size: 16px;
          }
        }
        &__icon {
          width: 25%;
          // background: rgb(126, 80, 87);
          display: inline-flex;
          justify-content: center;
          align-content: center;
          align-items: center;
          img {
            width: 23px;
          }
          @media screen and (max-width: 930px) {
            width: 10%;
            height: auto;
          }
        }
      }
      &__row-stats {
        width: 76.67%;
        // background: silver;
        height: 36px;
        display: inline-flex;
        justify-content: space-between;
        align-content: center;
        align-items: center;
        @media screen and (max-width: 930px) {
          width: 100%;
        }
        &__home-team {
          width: 50%;
          height: 36px;
          // background: red;
          display: inline-flex;
          justify-content: left;
          align-content: center;
          align-items: center;
          &__shield {
            width: 10%;
            height: 36px;
            // background: cyan;
            display: inline-flex;
            justify-content: center;
            align-content: center;
            align-items: center;
            img {
              width: 20px;
              @media screen and (max-width: 930px) {
                width: 24px;
              }
            }
            @media screen and (max-width: 500px) {
              width: 15%;
            }
            @media screen and (max-width: 400px) {
              width: 22%;
            }
          }
          &__goals-cont-items {
            width: 90%;
            height: 36px;
            // background: magenta;
            display: inline-flex;
            justify-content: left;
            align-content: center;
            align-items: center;
            @media screen and (max-width: 500px) {
              width: 85%;
            }
            @media screen and (max-width: 400px) {
              width: 78%;
            }
            &__goal {
              width: 12%;
              height: 36px;
              // background: brown;
              font-size: 13px;
              font-weight: 500;
              font-stretch: normal;
              font-style: normal;
              line-height: 36px;
              letter-spacing: normal;
              text-align: center;
              color: #132839;
              font-family: 'Avenir-Medium';
              @media screen and (max-width: 500px) {
                width: 18%;
              }
              @media screen and (max-width: 400px) {
                width: 22%;
              }
            }
          }
        }
        &__away-team {
          width: 50%;
          height: 36px;
          // background: red;
          display: inline-flex;
          justify-content: left;
          align-content: center;
          align-items: center;
          &__shield {
            width: 10%;
            height: 36px;
            // background: cyan;
            display: inline-flex;
            justify-content: center;
            align-content: center;
            align-items: center;
            img {
              width: 20px;
              @media screen and (max-width: 930px) {
                width: 24px;
              }
            }
            @media screen and (max-width: 500px) {
              width: 15%;
            }
            @media screen and (max-width: 400px) {
              width: 22%;
            }
          }
          &__goals-cont-items {
            width: 90%;
            height: 36px;
            // background: magenta;
            display: inline-flex;
            justify-content: left;
            align-content: center;
            align-items: center;
            @media screen and (max-width: 500px) {
              width: 85%;
            }
            @media screen and (max-width: 400px) {
              width: 78%;
            }
            &__goal {
              width: 12%;
              height: 36px;
              // background: brown;
              font-size: 13px;
              font-weight: 500;
              font-stretch: normal;
              font-style: normal;
              line-height: 36px;
              letter-spacing: normal;
              text-align: center;
              color: #132839;
              font-family: 'Avenir-Medium';
              @media screen and (max-width: 500px) {
                width: 18%;
              }
              @media screen and (max-width: 400px) {
                width: 22%;
              }
            }
          }
        }
      }
    }
  }
}
</style>
